export const IS_LOGGED_IN = 'IS_LOGGED_IN';
export const SHOW_MSG = 'SHOW_MSG';
export const HIDE_MSG = 'HIDE_MSG';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const GET_CERTIFICATES = 'GET_CERTIFICATES';
export const GET_NEW_REQUEST_FIELDS = 'GET_NEW_REQUEST_FIELDS';
export const GET_WEB_SERVICE_USERS = 'GET_WEB_SERVICE_USERS';
export const GET_USERS = 'GET_USERS';
export const GET_LOG_OPERATIONS = 'GET_LOG_OPERATIONS';
export const GET_ROLES = 'GET_ROLES';
export const GET_LOGS = 'GET_LOGS';
export const GET_SYSTEM_INFORMATION = 'GET_SYSTEM_INFORMATION';
export const GET_CONFIGURATION = 'GET_CONFIGURATION';
export const GET_CERTIFICATE_INFO = 'GET_CERTIFICATE_INFO';
export const GET_CERTIFICATE_TYPES = 'GET_CERTIFICATE_TYPES';
export const GET_WEBSERVICE_USER_INFO= 'GET_WEBSERVICE_USER_INFO';
export const GET_CRL_REASONS = 'GET_CRL_REASONS';
export const GET_CERTIFICATE_STATUS = 'GET_CERTIFICATE_STATUS';
export const CLEAR_STATE = 'CLEAR_STATE';
export const HIDE_MODAL= 'HIDE_MODAL';
export const SHOW_MODAL= 'SHOW_MODAL';

